import Distributor from "./distributor";
import School from "./school";
import App from "./app";
import OrderDetail from "./order-detail";
import OrderStatus from "@/shared/models/enums/order-status";
import { isNud } from '@/shared/utilities/typing'
import { dateYmd, dateYmdForInputDate } from '@/shared/utilities/date-format';

/**
 * 注文 エンティティ
 */
class Order {
    order_id;
    order_datetime;
    distributor;
    school;
    app;
    order_status;
    year;
    product_code;
	teacher_number;
	note;
	admin_note;
	total_account_number;
	unit_price;
	total_price;
	details;
	shipping_fee;
    shipping_date;
    shipped_date;
    shipping_method;
    email;
    recipient_name;
    recipient_phone;
    repocraft_evaluation;

    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }

        this.order_id = properties.order_id;
        this.order_datetime = properties.order_datetime;
        this.distributor = new Distributor(properties.distributor);
        this.school = new School(properties.school);
        this.app = new App(properties.app);
        this.order_status = properties.order_status;
        this.year = properties.year;
        this.product_code = properties.product_code;
        this.teacher_number = properties.teacher_number;
        this.note = properties.note;
        this.admin_note = properties.admin_note;
        this.total_account_number = properties.total_account_number;
        this.unit_price = properties.unit_price;
        this.total_price = properties.total_price;
        this.shipping_fee = properties.shipping_fee;
        this.shipping_date = properties.shipping_date;
        this.shipped_date = properties.shipped_date;
        this.shipping_method = properties.shipping_method;
        this.email = properties.email;
        this.recipient_name = properties.recipient_name;
        this.recipient_phone = properties.recipient_phone;
        this.repocraft_evaluation = properties.repocraft_evaluation;

        this.details = [];
        if ('details' in properties) {
            for (let detail of properties.details) {
                this.details.push(new OrderDetail(detail));
            }
        }
    }

    get order_status_display() {
        return OrderStatus.get(this.order_status);
    }

    get order_status_display_for_distributor() {
        return OrderStatus.getForDistributor(this.order_status);
    }

    get order_datetime_display() {
        return dateYmd(this.order_datetime);
    }

    get shipping_date_display() {
        if (isNud(this.shipping_date)) {
            return '-';
        }
        return dateYmd(this.shipping_date);
    }

    get shipped_date_display() {
        if (isNud(this.shipped_date)) {
            return '-';
        }
        return dateYmd(this.shipped_date);
    }

    get shipping_date_for_input() {
        return dateYmdForInputDate(this.shipping_date);
    }

    /**
     * setter
     */
    set shipping_date_for_input(value) {
        return this.shipping_date = value;
    }
}

export default Order;
